import { toast } from "react-toastify";
import { DeletePathAPI } from "../../../API/PathAPI";
import useModal from "../../../Hooks/useModal";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { PathModel } from "../../../Models/PathModel";
import { PathsColumns } from "../../../Static/PathsColumns";
import TableDefault from "../../Shared/TableDefault";
import EditPathComponent from "../EditPathComponent";
import { useState } from "react";

interface IPathTableComponentProps {
    paths: PathModel[],
    total: number,
    getPaths: (page?: number) => Promise<void>,
    setSearchTextPath: React.Dispatch<React.SetStateAction<string>>,
    pathMain: string,
    companyId: string,
    toggleLoading: (data: boolean) => void,
    getFiles: (page?: number) => Promise<void>,
    setPathsHasChanged: React.Dispatch<React.SetStateAction<boolean>>,
    userEmail: string,
    canNotDoNothing: boolean
}

const PathTableComponent = (props: IPathTableComponentProps) => {
    const { showModal: showEdit, toggleShowModal: toggleShowEdit } = useModal();
    const [ pathToEdit, setPathToEdit ] = useState({});

    const editPath = (path: PathModel) => {
        setPathToEdit(path);
        toggleShowEdit();
    }

    const deletePath = async (id: string) => {
        try {
            props.toggleLoading(true);

            await DeletePathAPI(id, props.companyId, props.pathMain).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    toast.success("Pasta deletada com sucesso!");
                    props.getPaths();
                    props.getFiles();
                }
            }).finally(() => props.toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            props.toggleLoading(false);
        }
    }

    return (
        <div className="d-flex flex-column w-100 ms-1">
            <EditPathComponent
                handleClose={toggleShowEdit}
                path={pathToEdit as PathModel}
                setPathsHasChanged={props.setPathsHasChanged}
                show={showEdit}
                toggleLoading={props.toggleLoading}
                userEmail={props.userEmail}
                pathMain={props.pathMain}
            />
            <input onBlur={() => props.getPaths()} className="form-control mb-2 w-25 align-self-end" placeholder="buscar pasta..." onChange={(e: any) => props.setSearchTextPath(e.target.value)} />
            <TableDefault
                columns={PathsColumns}
                hasHeader={true}
                hasPagination={true}
                firstColumnIsLink={true}
                linkToFirstColumn={`/fileManager/pathManager/${props.companyId}/${props.pathMain}/`}
                rows={props.paths}
                lastColumnIsAction={!props.canNotDoNothing}
                hasDelete={true}
                functionToDelete={deletePath}
                hasEdit={true}
                editIsButton={true}
                functionToEdit={editPath}
                total={props.total}
                pathMain={props.pathMain}
            />
        </div>
    )
}

export default PathTableComponent;